import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { IoSearchOutline } from 'react-icons/io5';

import styles from './styles.module.css';
import courseImage from 'src/assets/images/course_header.jpg';
import CoursesPagination from './pagination/Pagination';
import Post from './item/Item';

import { Spinner, Error as MyError } from 'src/Components';

import BASE_URL from 'src/constants/vars';
import { CourseItemType } from 'src/types/courses';
import useScrollToTop from 'src/hooks/useScrollToTop';

function List() {
    const [text, setText] = useState("");
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);

    const featchCourses = async () => {
        const res = await fetch(
            `${BASE_URL}/courses/?page=${page}${search ? `&search=${search}` : ''}`
        );
        return res.json();
    };

    const { data, error, isLoading, isError, isFetching } = useQuery({
        queryKey: ['coursesData', page, search],
        queryFn: featchCourses,
        keepPreviousData: true,
    });

    const pagesNum = data ? data.pages_num : 0;

    const onSubmit = (evt: React.FormEvent) => {
        evt.preventDefault();

        // reset pagination on new search
        setPage(1);

        // if input is empty → reset search
        if (!text.trim()) {
            setSearch("");
            return;
        }

        // otherwise search normally
        setSearch(text);
    };

    useScrollToTop();

    if (isError) {
        let msg = "حدث خطأ ما";
        if (error instanceof Error) msg = error.message;
        return <MyError msg={msg} />;
    }

    return (
        <section className={styles.coursesListCon}>
            <header className={styles.header}>
                <div className={styles.title}>
                    <h4>تصفح دوراتنا التدريبية</h4>
                </div>
                <img src={courseImage} alt="" />
            </header>

            <div className={"container"}>
                <div className={styles.sHeader}>
                    <h4>الدورات التدريبية</h4>

                    <form onSubmit={onSubmit}>
                        <input
                            type="text"
                            placeholder="البحث"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        />
                        <button type="submit">
                            <IoSearchOutline size={20} />
                        </button>
                    </form>
                </div>

                <div className="row">
                    {isLoading || isFetching ? (
                        <div className="my-5">
                            <Spinner height={70} width={70} />
                        </div>
                    ) : data?.results?.length ? (
                        data.results.map((item: CourseItemType) => (
                            <div key={item.slug} className="col-12 col-md-6 col-lg-4">
                                <Post item={item} />
                            </div>
                        ))
                    ) : (
                        <p className={styles.notFound}>
                            لا يوجد أي دورات تدريبية
                        </p>
                    )}
                </div>

                {data?.results?.length > 0 && (
                    <CoursesPagination
                        page={page}
                        next={data?.next}
                        previous={data?.previous}
                        setPage={setPage}
                        pagesNum={pagesNum}
                    />
                )}
            </div>
        </section>
    );
}

export default List;
